module.exports = __webpack_public_path__ + "img/logo_light.48e2bc5d.png";